"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsTeaser = exports.ScalableImage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_fusion_bs_media_card_1 = require("@hotelplan/core.fusion.bs-media-card");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
exports.ScalableImage = (0, styled_components_1.default)(core_fusion_bs_media_card_1.BsMediaCard)({
    width: '100%',
    overflow: 'hidden',
    ':before': {
        zIndex: 2,
    },
    ':after': {
        content: "''",
        display: 'block',
        width: '100%',
        paddingBottom: '83%',
        pointerEvents: 'none',
    },
    'img, .video': {
        position: 'absolute',
        display: 'block',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        maxHeight: '100%',
    },
});
const TeaserCardWrapper = styled_components_1.default.div({
    position: 'relative',
    '.media-card-content': {
        position: 'absolute',
        textAlign: 'left',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column-reverse',
        '.card-subtitle': {
            display: 'inline',
        },
        '.chevron-icon': {
            transform: 'rotate(180deg)',
        },
    },
}, ({ theme }) => theme.card.teaserCard || {});
function BsTeaser(props) {
    const { image, link, subTitle, title, children, icon } = props, divProps = __rest(props, ["image", "link", "subTitle", "title", "children", "icon"]);
    return (react_1.default.createElement(TeaserCardWrapper, Object.assign({}, divProps),
        react_1.default.createElement(exports.ScalableImage, { link: link ? (0, libs_router_link_utils_1.getRouterLink)(link) : undefined, openMethod: (0, libs_router_link_utils_1.getOpenMethod)(link), title: title ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "card-image-title" }, title),
                icon)) : null, subTitle: subTitle, className: "teaser-media", imageElement: image }, children)));
}
exports.BsTeaser = BsTeaser;
//# sourceMappingURL=bs-teaser.js.map